export const terms = {
label: 'LEGAL',
title: 'Terms of Service',
last_updated: 'Last Updated: January 2024',
intro: 'These Terms of Service ("Terms") govern your access to and use of the One More Global Inc. website. By accessing or using our website, you agree to be bound by these Terms.',
use_title: 'Use of Website',
use_text: 'You may use our website only for lawful purposes and in accordance with these Terms. You agree not to use the website in any way that could damage, disable, or impair the website.',
ip_title: 'Intellectual Property',
ip_text: 'The website and its entire contents, features, and functionality are owned by One More Global Inc. and are protected by international copyright, trademark, and other intellectual property laws.',
disclaimer_title: 'Disclaimer',
disclaimer_text: 'The information provided on this website is for general informational purposes only. While we strive to keep the information current and accurate, we make no representations or warranties of any kind.',
liability_title: 'Limitation of Liability',
liability_text: 'In no event shall One More Global Inc. be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the website.',
governing_title: 'Governing Law',
governing_text: 'These Terms shall be governed by and construed in accordance with the laws of the State of Texas, United States, without regard to its conflict of law provisions.',
contact_title: 'Contact Us',
contact_text: 'If you have questions about these Terms, please contact us at our corporate office.',
};
